import {CampaignIO} from "../../../io/campaign/campaignIO";
import {CampaignDataTransferObject} from "../../../model/dto/campaign/CampaignDataTransferObject";
import {Button, Field, FieldProps, Image, Input, Label, Radio, RadioGroup} from "@fluentui/react-components";
import {RouteContext} from "../../RouteContext";
import {Styles} from "../common/Styles";
import {InputStringStatePair, StatePair, useError, useInputString, useStatePair} from "../../../type/States";
import {DataTransferObjectValidation} from "../../../type/Types";
import {Column, Row} from "../common/Layout";
import React, {useEffect} from "react";
import {CampaignCode} from "../../../constant/CampaignCode";


export default function Post(props: RouteContext) {
    const styles = Styles.useEditorStyles()

    const [bannerImageFile, setBannerImageFile] = React.useState<File>();
    const [iconImageFile, setIconImageFile] = React.useState<File>();
    const [bannerPreviewImageFile, setBannerPreviewImageFile] = React.useState<string>();
    const [iconPreviewImageFile, setIconPreviewImageFile] = React.useState<string>();

    useEffect(() => {
        if (bannerImageFile) {
            const preview = URL.createObjectURL(bannerImageFile)
            setBannerPreviewImageFile(preview)
        }
    }, [bannerImageFile])

    useEffect(() => {
        if (iconImageFile) {
            const preview = URL.createObjectURL(iconImageFile)
            setIconPreviewImageFile(preview)
        }
    }, [iconImageFile])

    const inputStates: Record<keyof CampaignDataTransferObject.Post, InputStringStatePair> = {
        landingUrl: useInputString(''),
        title: useInputString(''),
        description: useInputString(''),
        bannerImageUrl: useInputString(''),
        iconImageUrl: useInputString(''),
        category: useInputString(''),
        point : useInputString(''),

    }
    const inputValidationStates: Record<keyof CampaignDataTransferObject.Post, StatePair<FieldProps['validationState']>> = {
        landingUrl: useStatePair<FieldProps['validationState']>('none'),
        title: useStatePair<FieldProps['validationState']>('none'),
        description: useStatePair<FieldProps['validationState']>('none'),
        bannerImageUrl: useStatePair<FieldProps['validationState']>('none'),
        iconImageUrl: useStatePair<FieldProps['validationState']>('none'),
        category: useStatePair<FieldProps['validationState']>('none'),
        point :useStatePair<FieldProps['validationState']>('none'),
    }
    const postErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.landingUrl.setValue('none')
        inputValidationStates.title.setValue('none')
        inputValidationStates.description.setValue('none')
        inputValidationStates.bannerImageUrl.setValue('none')
        inputValidationStates.iconImageUrl.setValue('none')
        inputValidationStates.category.setValue('none')
        inputValidationStates.point.setValue('none')

        try {
            const dto: CampaignDataTransferObject.Post = {
                landingUrl: DataTransferObjectValidation.validate(CampaignDataTransferObject.Post.validation, 'landingUrl', inputStates.landingUrl.value, () => inputValidationStates.landingUrl.setValue('error')),
                title: DataTransferObjectValidation.validate(CampaignDataTransferObject.Post.validation, 'title', inputStates.title.value, () => inputValidationStates.title.setValue('error')),
                description: DataTransferObjectValidation.validate(CampaignDataTransferObject.Post.validation, 'description', inputStates.description.value, () => inputValidationStates.description.setValue('error')),
                bannerImageUrl: DataTransferObjectValidation.validate(CampaignDataTransferObject.Post.validation, 'bannerImageUrl', inputStates.bannerImageUrl.value, () => inputValidationStates.bannerImageUrl.setValue('error')),
                iconImageUrl: DataTransferObjectValidation.validate(CampaignDataTransferObject.Post.validation, 'iconImageUrl', inputStates.iconImageUrl.value, () => inputValidationStates.iconImageUrl.setValue('error')),
                category: DataTransferObjectValidation.validate(CampaignDataTransferObject.Post.validation, 'category', inputStates.category.value, () => inputValidationStates.category.setValue('error')),
                point: DataTransferObjectValidation.validate(CampaignDataTransferObject.Post.validation, 'point', inputStates.point.value, () => inputValidationStates.point.setValue('error')),
            }

        CampaignIO.post(dto)
            .then((value: any)=>{

                if(bannerImageFile != null){

                    const formData = new FormData()
                    formData.append('file', bannerImageFile)

                    fetch(`${process.env.REACT_APP_API_HOST}/api/v3/campaigns/${value.id}/bannerImage`,
                        {
                            method: 'PATCH',
                            body: formData,
                        },
                    )
                        .then(async value => {
                            const res = await value.json()
                            console.log(res)

                            if (!res) {
                                alert('배너 이미지 업로드에 실패했습니다.')
                                return
                            }



                        })
                }

                if(iconImageFile != null){

                    const formData = new FormData()
                    formData.append('file', iconImageFile)

                    fetch(`${process.env.REACT_APP_API_HOST}/api/v3/campaigns/${value.id}/iconImage`,
                        {
                            method: 'PATCH',
                            body: formData,
                        },
                    )
                        .then(async value => {
                            const res = await value.json()
                            console.log(res)

                            if (!res) {
                                alert('가이드라인 이미지 업로드에 실패했습니다.')
                                return
                            }



                        })
                }
                window.alert('추가되었습니다.')
            })
            .catch(postErrorState.setDefinedValue)

    } catch (error) {
        console.error(error)
    }

    }

    return <>
        <postErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={CampaignDataTransferObject.Post.description.category}
                validationState={inputValidationStates.category.value}>
                <RadioGroup
                    value={inputStates.category.value}
                    onChange={(_, data) => inputStates.category.setValue(data.value)}>
                    {Object.entries(CampaignCode).map(([key, value]) => (
                        <Radio
                            key={value}
                            value={value}
                            label={key}
                        />
                    ))}
                </RadioGroup>
            </Field>
            <Field
                className={styles.field}
                label={CampaignDataTransferObject.Post.description.landingUrl}
                validationState={inputValidationStates.landingUrl.value}>
                <Input
                    value={inputStates.landingUrl.value}
                    onChange={inputStates.landingUrl.onChange}/>
            </Field>
            <Field
                className={styles.field}
                label={CampaignDataTransferObject.Post.description.title}
                validationState={inputValidationStates.title.value}>
                <Input
                    value={inputStates.title.value}
                    onChange={inputStates.title.onChange}/>
            </Field>
            <Field
                className={styles.field}
                label={CampaignDataTransferObject.Post.description.description}
                validationState={inputValidationStates.description.value}>
                <Input
                    value={inputStates.description.value}
                    onChange={inputStates.description.onChange}/>
            </Field>
            <Label>배너 이미지</Label>
            <input type="file"
                   onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                       if (event.target.files) {
                           setBannerImageFile(event.target.files[0])
                       }
                   }}
                   accept="image/*"
            />
            {
                bannerPreviewImageFile &&
                (
                    <div>
                        <Image
                            src={bannerPreviewImageFile}
                            alt="배너이미지"
                            width={200}
                            height={200}
                        />
                    </div>
                )
            }
            <Label>아이콘 이미지</Label>
            <input type="file"
                   onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                       if (event.target.files) {
                           setIconImageFile(event.target.files[0])
                       }
                   }}
                   accept="image/*"
            />
            {
                iconPreviewImageFile &&
                (
                    <div>
                        <Image
                            src={iconPreviewImageFile}
                            alt="아이콘이미지"
                            width={200}
                            height={200}
                        />
                    </div>
                )
            }
            <Field
                className={styles.field}
                label={CampaignDataTransferObject.Post.description.point}
                validationState={inputValidationStates.point.value}>
                <Input
                    value={inputStates.point.value}
                    onChange={inputStates.point.onChange}/>
            </Field>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={()=>onDoneClick()}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}